core.constant('patientMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "ERROR": {
          "DUPLICATED_PATIENT_PESEL": "Wystąpił błąd podczas zapisu! Istnieje już pacjent o podanym numerze PESEL!",
          "DUPLICATED_PATIENT_EMAIL": "Wystąpił błąd podczas zapisu! Istnieje już pacjent o podanym adresie email!",
          "DUPLICATED_PATIENT_FILE_NUMBER": "Wystąpił błąd podczas zapisu! Istnieje już pacjent o podanym numerze kartoteki!",
          "DUPLICATED_PATIENT_NIP": "Wystąpił błąd podczas zapisu! Istnieje już pacjent o podanym numerze NIP!",
          "DUPLICATED_PATIENT_IDENTITY_DOCUMENT_NUMBER": "Wystąpił błąd podczas zapisu! Istnieje już pacjent o podanym numerze dokumentu!",
          "PATIENT_HAS_ACTIVE_VISITS": "Wystąpił błąd podczas usuwania! Istnieją aktywne wizyty przypisane do pacjenta!",
          "PATIENT_INCORRECT_PESEL": "Wystąpił błąd podczas zapisu! Podano niepoprawny numer PESEL!",
          "PATIENT_NO_CORRESPONDENCE_BETWEEN_GENDER_AND_PESEL": "Wystąpił błąd podczas zapisu! Podany płeć nie jest zgodna z wartością wynikającą z numeru PESEL!",
          "PATIENT_NO_CORRESPONDENCE_BETWEEN_BIRTH_DATE_AND_PESEL": "Wystąpił błąd podczas zapisu! Podana data urodzenia nie jest zgodna z wartością wynikającą z numeru PESEL!"
        }
      },
      "UI": {
        "TAB": {
          "STATE_OF_HEALTH" : "Stan zdrowia",
          "VISIT_LIST" : "Wizyty",
          "RECOGNITION" : "Rozpoznanie",
          "PROCEDURES" : "Procedury",
          "RELEASE" : "Zwolnienia",
          "PRESCRIPTION" : "Recepty",
          "PERSONAL_DATA" : "Dane osobowe",
          "VISIT_CARD": "Karta wizyty",
          "VISIT_HISTORY": "Historia wizyt"
        },
        "VISIT_HEADER" : {
          "CONTROL_VISIT" : "Wizyta kontrolna",
          "PLANNED" : "Zaplanowana",
          "TOOK_PLACE" : "Odbyła się"
        },
        "SIDEBAR_ITEMS": {
          "MAIN": "Główna",
          "PATIENTS": "Pacjenci",
          "VIDEO_CONSULTING": "Wideokonsultacje",
          "BUSINESS_INTELLIGENCE": "Business Intelligence",
          "SIMULATIONS": "Symulacje",
          "EXPERT_SYSTEM": "System ekspercki",
          "BILLINGS": "Rozliczenia",
          "PAYMENTS": "Płatności",
          "SETTINGS": "Ustawienia",
          "BASE_OF_CASES": "Baza przypadków",
          "MESSAGES" : "Komunikaty",
          "SETTINGS" : "Ustawienia",
          "CALENDAR" : "Kalendarz",
          "AVAILABILITY" : "Edycja dostępności"
        },
        "SIDEBAR_ITEMS_STATE_OF_HEALTH": {
          "GENERAL": "Ogólny",
          "ALLERGIES": "Alergie",
          "TAKEN_DRUGS": "Aktualnie przyjmowane leki",
          "DIAGNOSES": "Przewlekłe i przebyte choroby",
          "HOSPITAL_AND_SANATORIUMS": "Pobyty szpitalne i sanatoryjne",
          "LABORATORY_TEST_RESULTS": "Badania laboratoryjne",
          "VACCINATION_AND_SERUMS": "Szczepienia i stosowane surowice",
          "GENETIC_DISORDERS": "Obciążenia dziedziczne"
        }
      },
      "MODULE": {
        "PATIENT": {
          "PATIENT": "Pacjent",
          "PATIENTS": "Pacjenci",
          "ALLERGIES": "Alergie",
          "TYPE": "Rodzaj",
          "NOTES": "Uwagi",
          "CHRONIC_AND_PAST_ILLNESS": "Przewlekłe i przebyte choroby",
          "CHRONIC": "Przewlekła",
          "CHRONIC_ILLNESS": "Przewklekła choroba",
          "DOCUMENT": "Dokument",
          "RECOGNITION": "Rozpoznanie",
          "HOSPITALS_AND_SANATORIUM": "Pobyty szpitalne i sanatoria",
          "LABORATORY_TEST_RESULTS": "Badania Laboratoryjne",
          "INSERT_DATE": "Data wprowadzenia",
          "LAB_TEST_NAME": "Nazwa badania",
          "ATTACHMENT": "Załącznik",
          "VACCINATION_AND_SERUM": "Szczepienia i stosowane surowice",
          "VACCINE_NAME": "Nazwa szczepionki",
          "TAKEN_DRUGS": "Aktualnie przyjmowane leki",
          "DRUG_NAME": "Nazwa Leku",
          "GENETIC_DISORDERS": "Obciążanie dziedziczne",
          "DISORDER_NAME": "Nazwa choroby",
          "DIAGNOSIS": "Diagnoza",
          "ALLERGY_SAVE": "Dodaj uczulenie",
          "ALLERGY_UPDATE": "Edytuj uczulenie",
          "ALLERGY": "Alergia",
          "ALLERGY_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć uczulenie: ",
          "ILLNESS_SAVE": "Dodaj przewlekłą/przebytą chorobę",
          "ILLNESS_UPDATE": "Edytuj przewklekłą/przebytą chorobę",
          "ILLNESS_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć chorobę: ",
          "HOSPITAL_AND_SANATORIUM_SAVE": "Dodaj pobyt szpitalny lub sanatoryjny",
          "HOSPITAL_AND_SANATORIUM_UPDATE": "Edytuj pobyt szpitalny lub sanatoryjny",
          "HOSPITAL_AND_SANATORIUM_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć pobyt: ",
          "LABORATORY_RESULT_SAVE": "Dodaj badanie laboratoryjne",
          "LABORATORY_RESULT_UPDATE": "Edytuj badanie laboratoryjne",
          "LABORATORY_RESULT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć badanie: ",
          "LABORATORY_ADD_ATTACHMENT": "Dodaj załącznik",
          "VACCINATION_AND_SERUM_SAVE": "Dodaj szczepienie",
          "VACCINATION_AND_SERUM_UPDATE": "Edutyj szczepienie",
          "VACCINATION_AND_SERUM_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć szczepienie: ",
          "VISIT_HISTORY" : "Historia odwiedzin",
          "TAKEN_DRUG_CHRONIC": "Przyjmowany przewlekle",
          "TAKEN_DRUG_SAVE": "Dodaj lek",
          "TAKEN_DRUG_UPDATE": "Edytuj lek",
          "TAKEN_DRUG_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć lek: ",
          "GENETIC_DISORDER_SAVE": "Dodaj chorobę dziedziczną",
          "GENETIC_DISORDER_UPDATE": "Edytuj chorobę dziedziczną",
          "GENETIC_DISORDER_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąc chorobę: ",
          "INPUT_DATE": "Data wprowadzenia",
          "PRESENT": "Aktualne",
          "START_TYPING_TO_FIND": "Wpisz aby znaleźć...",
          "EWUS": "EWUŚ",
          "DRUG": "Lek",
          "PACKAGE": "Opakowanie",
          "ADD_DATE": "Data dodania",
          "INSERT_FIRST_OR_LAST_NAME_OR_IDENTIFIER": "Wpisz imię, nazwisko lub PESEL...",
          "CHRONIC_ICD_10": "Przewklekłe",
          "INSERT_AT_LEAST_ONE_ICD_10": "Wprowadź przynajmniej jedno rozpoznanie.",
          "NUMBER": "Liczba",
          "TIMES": "Krotność",
          "ELEMENTS_PER_PAGE": "Elementów na stronę",
          "TAKEN_DRUG_CHRONIC": "Brany przewlekle"
        },
        "VISIT" : {
          "MEDICAL_TEMPLATES": {
            "PRESCRIPTION_RP": "Recepta Rp",
            "PRESCRIPTION_RPW":  "Recepta Rpw",
            "PRESCRIPTION_RCP":  "Recepta Rcp",
            "E_REFERRAL": "eSkierowanie",
            "REFERRAL_SPECIALIST": "Skierowanie do specjalisty",
            "REFERRAL_HOSPITAL": "Skierowanie do szpitala",
            "REFERRAL_DIAGNOSTIC": "Skierowanie do pracowni diagnostycznej",
            "REFERRAL_LABORATORY": "Skierowanie na badania laboratoryjne",
            "REFERRAL_GENERAL": "Skierowanie (druk ogólny)",
            "SICK_LEAVE": "Zwolnienie lekarskie",
            "HEALTH_CARE_CONSENT": "Zgoda na świadczenie usług zdrowotnych",
            "MEDICAL_FILES_PICK_UP_AUTHORIZATION": "Upoważnienie do odbioru dokumentacji medycznej",
            "EWUS_STATEMENT": "Oświadczenie EWUŚ",
            "INSURANCE_STATEMENT": "Zaświadczenie o stanie zdrowia (druk N9, N14)",
            "GENERAL_DOCUMENT": "Dokument ogólny"
          },
          "CLINIC": "Placówka",
          "DATE_AND_TIME": "Data i czas",
          "DRUGS": "Leki",
          "EPICRISIS" : "Karta wizyty",
          "SHOW_EPIKRYZA" : "Pokaż kartę wizyty",
          "PREVIEW_EPIKRYZA": "Podgląd karty wizyty",
          "SAVE_VISIT": "Zapisz wizytę",
          "ENCLOSE_FILE": "Załącz plik",
          "STICK": "Wystaw",
          "INTERVIEW": "Wywiad",
          "SUBJECT_RESEARCH": "Badanie przedmiotowe",
          "ICD_10": "Rozpoznanie ICD-10",
          "MAIN_ICD_10": "Rozpoznanie ICD-10 (Główne)",
          "ICD_9": "Procedura ICD-9",
          "CHOOSE_DRUG": "Wybierz lek",
          "DOCTOR_ORDER": "Zalecenia lekarskie",
          "DOCUMENT_LIST": "Lista dokumentow",
          "RECOMMENDED_PRESCRIPTIONS": "Zalecane leki",
          "PRESCRIPTION": "Recepta",
          "MEDICAL_PRIVATE_PRACTICE": "Indywidualna Praktyka Lekarska",
          "REGON": "REGON",
          "PATIENT": "Pacjent",
          "NFZ_BRANCH": "Oddział NFZ",
          "PESEL": "PESEL",
          "ADDITIONAL_PERMISSIONS": "Dodatkowe uprawnienia",
          "PAYMENT": "Odpłatność",
          "DOSAGE": "Dawkowanie",
          "SUMMARY_DOSAGE": "Sumaryczna ilość substancji czynnej (słownie)",
          "COUNT": "Liczba",
          "POST_DATE": "Data wystawienia",
          "REALIZATION_DATE": "Data realizacji \"od dnia\"",
          "DOCTOR_SIGNATURE": "Dane i podpis lekarza",
          "INSERT_DATE": "Wprowadź datę",
          "INSERT_ICD": "Wprowadź",
          "RECOGNITIONS": "Rozpoznania",
          "PROCEDURES": "Procedury",
          "INSERT_ICD10_CODE": "Wpisz kod icd10 lub nazwę rozpoznania...",
          "INSERT_ICD9_CODE": "Wpisz kod icd9 lub nazwę procedury...",
          "ENTER_DRUG_NAME": "Wpisz nazwę leku...",
          "B": "B",
          "R": "R",
          "_30": "30%",
          "_50": "50%",
          "_100": "100%",
          "PATIENT_FULL_NAME": "Imię i nazwisko",
          "SPECIALIST_REFERRAL": "Skierowanie do specjalisty",
          "SPECIALIST_CLINIC_REFERRAL": "Skierowanie do poradni specjalistycznej",
          "CLINIC_NAME": "Nazwa poradni",
          "ASK_FOR": "Proszę o",
          "SPECIALIST_ADVISORY": "Poradę specjalistyczną",
          "SPECIALIST_TREATMENT": "Objęcie leczeniem specjalistycznym",
          "ADDRESS": "Adres",
          "YEARS_OLD": "Lat",
          "RECOGNITION": "Rozpoznanie",
          "COUNSEL_POINT": "Cel porady",
          "PREVIOUS_EXAMINATION": "Dotychczasowe badania",
          "SPECIALIST_CLINIC_NOTES": "Uwagi poradni specjalistycznej",
          "DATE_OF_PATIENT_NOTIFY": "Data zgłoszenia się pacjenta ze skierowaniem",
          "TERM_OF_COUNSEL": "Termin wyznaczonej porady",
          "DOCTOR_SIGNATURE": "Dane i podpis lekarza",
          "SIGNATURE": "Dane i podpis",
          "FOR_MS_OR_MR": "u Pani / Pana",
          "HOSPITAL_REFERRAL": "Skierowanie do szpitala",
          "REDIRECT_MS_OR_MR": "Kieruję Panią / Pana",
          "TO_HOSPITAL_INSTITUTE": "Do szpitala, szpitala klinicznego, instytutu",
          "HOSPITAL_NAME": "Nazwa",
          "IN": "w",
          "HOSPITAL_UNIT": "Oddział",
          "PATIENT_ACCEPTANCE": "Termin uzgodnionego przyjęcia",
          "PHONE": "Telefon",
          "DIAGNOSTIC_CLINIC_REFERRAL": "Skierowanie do pracowni diagnostycznej",
          "ASK_FOR_EXAMINATION": "Proszę o badanie",
          "STUDIO_NAME": "Nazwa pracowni",
          "DIAGNOSTIC_STUDIO_NOTES": "Uwagi pracowni diagnostycznej",
          "TERM_OF_DIAGNOSTIC_EXAMINATION": "Wyznaczony termin badania",
          "EXAMINATION_POINT": "Cel badania",
          "LABORATORY_REFERRAL": "Skierowanie do laboratorium",
          "LABORATORY_CLINIC_REFERRAL": "Skierowanie na badania laboratoryjne",
          "PHONE_NUMBER": "Nr telefonu",
          "DOCUMENT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć dokument?",
          "NO_DIAGNOSIS_ADDED": "Nie dodałeś żadnego rozpoznania",
          "AUTHORIZED_PERSON_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć uprawnioną osobę?",
          "VISIT_TYPE": "Rodzaj wizyty",
          "NEW_VISIT": "Nowa wizyta",
          "EDIT_VISIT": "Edytuj wizytę",
          "INSERT_RCP_DESCRIPTION": "Wprowadź opis receptury",
          "STREET_HEAD": "ul.",
          "VIDEOCONSULTATION": "Wideokonsultacja",
          "VISIT_DELETE_CONFIRMATION": "Czy na pewno chcesz usunąć wizytę?",
          "CANNOT_OPEN_VISIT_CARD_FOR_THIS_VISIT": "Nie można otworzyć karty dla tej wizyty",
          "INSERT_PRESCRIPTION_DESCRIPTION": "Wprowadź opis receptury.",
          "NOT FILLED": "Nie wypełniono",
          "PREVIEW": "Podgląd",
          "DELETE": "Usuń",
          "PRINT": "Drukuj",
          "NO_ADVISED_DRUGS": "Brak zalecanych leków",
          "NEW_PATIENT": "Nowy pacjent",
          "QUALIFIER": "Kwalifikator",
          "INSERT_ICF_CODE_OR_DESCRIPTION": "Wprowadź kod icf lub opis...",
          "ICF_WISUALIZATION": "Wizualizacja wyników ICF",
          "ICF_CATEGORIES": "Kategorie ICF",
          "ICF_QUALIFIERS": "Kwalifikatory ICF",
          "PROBLEM": "Problem",
          "FACILITATOR": "Ułatwienie",
          "BARRIER": "Bariera",
          "FILL_ALL_QUALIFIERS_TO_SEE_REPORT": "Uzupełnij wszystkie pierwsze kwalifikatory aby zobaczyć raport",
          "FILL_ALL_QUALIFIERS_AND_AT_LEAST_ONE_ICD9_TO_SEE_SIMULATION": "Uzupełnij wszystkie pierwsze kwalifikatory oraz co najmniej jedno procedurę ICD-9 aby zobaczyć symulację",
          "STATE_OF_HEALTH_SIMULATION": "Symulacja stanu zdrowia",
          "ESTIMATE_RISK": "Oszacuj ryzyko",
          "TREATMENT_COST_SIMULATION": "Szacowanie kosztów leczenia",
          "CURRENT_STATE_OF_HEALTH_ABBR": "Stan bieżący",
          "EXPECTED_STATE_OF_HEALTH_ABBR": "Stan przewidywany",
          "SIMULATION_RESULT_ABBR": "Wynik",
          "SUGGESTED_ICD9_PROCEDURES": "Sugerowane procedury ICD9",
          "SELECTED_ICD9_PROCEDURE": "Procedura ICD9 w symulacji",
          "START_SIMULATION": "Uruchom symulację",
          "CHECK_COST": "Sprawdź koszt po zastosowaniu procedur",
          "SHOW_CHART": "Pokaż wykres",
          "BODY_STRUCTURES": "Struktury ciała",
          "BODY_FUNCTIONS": "Funkcje ciała",
          "ENVIRONMENT": "Środowisko",
          "ACTIVITIES_AND_PARTICIPATION": "Aktywność i uczestniczenie",
          "COST_WITHOUT_TREATMENT_ZL": "Koszt bez leczenia [zł]",
          "COST_SIMULATION_ZL": "Symulowany koszt po zastosowaniu procedury [zł]",
          "INSERT_COST": "Podaj koszt...",
          "COST_WITHOUT_TREATMENT": "Koszt bez leczenia",
          "PROCEDURE_COST": "Koszt procedury",
          "ESTIMATED_COST": "Koszt szacowany",
          "STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT": {
            "WORSE": "Pogorszenie",
            "SAME": "Bez zmian",
            "BETTER": "Poprawa"
          },
          "ADD_SIMULATION_RESULT_TO_DATA_SET": "Dodaj dane do zestawu uczącego"
        },
        "PERSONAL_DATA": {
          "GENERAL_DATA": "Dane ogólne",
          "REQUIRED_FIELD": "Wymagane pole",
          "INVALID_PESEL": "Nieprawidłowy PESEL",
          "INVALID_DATE": "Nieprawidłowa data",
          "FIRST_NAME": "Imię",
          "LAST_NAME": "Nazwisko",
          "FULL_NAME": "Imię i nazwisko",
          "DOCUMENT_TYPE": "Typ dokumentu",
          "DOCUMENT_NUMBER": "Numer dokumentu",
          "PESEL": "Pesel",
          "CONTACT_DATA": "Dane kontaktowe",
          "FILE_NUMBER": "Numer kartoteki",
          "CITIZENSHIP": "Obywatelstwo kraju",
          "GENDER": "Płeć",
          "EMAIL": "E-mail",
          "MOBILE_PHONE": "Nr tel. komórkowego",
          "EMAIL_SENDING_AGREEMENT": "Zgoda na wysyłkę e-mail",
          "REGISTER_ADDRESS": "Adres zameldowania",
          "STREET": "Ulica",
          "STREET_NUMBER": "Numer domu",
          "FLAT_NUMBER": "Numer mieszkania",
          "POST_CODE": "Kod pocztowy",
          "CITY": "Miasto",
          "STATE": "Województwo",
          "CORRESPONDENCE_ADDRESS": "Adres korespondencyjny",
          "CORRESPONDENCE_SAME_AS_REGISTER": "Taki sam jak zameldowania",
          "ADD_AUTHORIZED_PERSON": "Dodaj osobę upoważnioną lub Opiekuna",
          "BIRTH_DATE": "Data urodzenia",
          "INVALID_EMAIL": "Nieprawidłowy adres e-mail",
          "IDENTIFIER": "Identyfikator",
          "REQUIRED_FIELDS_INFORMATION": "Wypełnij wszystkie wymagane pola",
          "DOCUMENTS": "Dokumenty",
          "PATIENT_STATEMENTS": "Oświadczenia pacjenta",
          "AUTHORIZED_PERSONS": "Osoby upoważnione",
          "PREVIEW_AND_EDIT": "Podgląd i edycja",
          "PRINT_TEMPLATE": "Drukuj wzór",
          "PREVIEW_ATTACHMENT": "Podgląd załącznika",
          "AUTHORIZATION_FOR_MEDICAL_FILES_PICK_UP": "Upoważnienie do odbioru dok. med.",
          "PERSONAL_FILES_AND_OTHER_ATTACHMENTS": "Dokumenty osobowe / inne załączniki",
          "AUTHORIZED_PERSON_TYPE": "Typ osoby upoważnianej",
          "UPDATE_EWUS_STATUS": "Zaktualizuj status w EWUŚ",
          "EWUS_STATUS": "Zarejestrowany w EWUŚ",
          "NOT_REGISTERED_IN_EWUS": "Niezarejestrowany w EWUŚ",
          "NFZ_OFFICE": "Oddział NFZ",
          "ADDITIONAL_INFORMATIONS": "Informacje dodatkowe",
          "NOTES": "Uwagi",
          "PUBLISH_PATIENT_DATA": "Opublikuj dane pacjenta",
          "WEIGHT_OF_PATIENT_DATA": "Waga danych pacjenta dla symulacji",
          "ACADEMIC_TITLE": "Tytuł akademicki",
          "SPECIALIZATION": "Specjalizacja",
          "COMPANY_NAME": "Nazwa firmy",
          "NIP": "NIP",
          "REGON": "REGON",
          "PERSONAL_DATA": "Dane osobowe",
          "COMPANY_ADDRESS": "Adres firmy",
          "NIP_NUMBER": "NIP pacjenta",
          "COMPANY_NIP": "NIP płatnika",
          "PWZ_NUMBER": "PWZ"
        }
      },
      "ENUM": {
        "ALLERGY_TYPE": {
          "OTHER": "Inne",
          "FOOD": "Jedzenie",
          "DRUGS": "Leki",
          "POLLEN": "Pyłki",
          "PATIENT_CLAIMS_NO_ALLERGIES": "Pacjent stwierdził, ze nie jest uczulony"
        },
        "TAKEN_DRUG_TYPE": {
          "NONE": "Brak",
          "FOOD": "Jedzenie",
          "DRUGS": "Leki",
          "POLLEN": "Pyłki"
        },
        "LABORATORY_TEST_RESULT_TYPE": {
          "RTG": "RTG",
          "USG": "USG",
          "MRI": "MRI",
          "TK": "TK",
          "LABORATORY_TEST" : "Badania laboratoryjne",
          "OTHER": "Inne"
        },
        "IDENTIFIER_TYPE": {
          "PESEL": "PESEL",
          "MOTHER_PESEL": "PESEL opiekuna prawnego",
          "OTHER": "Inny"
        },
        "IDENTITY_DOCUMENT_TYPE": {
          "ID": "Dowód osobisty",
          "PASSPORT": "Paszport"
        },
        "GENDER": {
          "FEMALE": "Kobieta",
          "MALE": "Mężczyzna"
        },
        "EXAMINATION_TYPE": {
          "SPECIALIST_ADVISORY": "poradę specjalistyczną",
          "SPECIALIST_TREATMENT": "objęcie leczeniem specjalistycznym"
        },
        "AUTHORIZED_PERSON_TYPE": {
          "PARENT": "Rodzic",
          "LEGAL_GUARDIAN": "Prawny opiekun",
          "ACTUAL_GUARDIAN": "Obecny opiekun",
          "OTHER_THAN_PARENT_STATUORY_GUARDIAN": "Inny niż opiekun ustawowy"
        }
      }
    }
  }
});


